import {RESP} from '../../../../_metronic/helpers/network/network-consts'
import type {Customer} from '../../sales-marketing/customer/core/_models'
import {getCustomers} from '../../sales-marketing/customer/core/_requests'

export type GymMember = {
  guid: string
  fullName: string
  phoneNumber: string
  email: string
  status: string
  profilePicture: string
  customerType: string
  gender: string
  dateOfBirth: string
  registeredOutlet: string
  address: string
  city: string
  province: string
}

export type MemberLookupResult =
  | {kind: 'found'; member: GymMember; outletName: string}
  | {kind: 'not-found'; phone: string; email: string}

const toGymMember = (customer: Customer): GymMember => ({
  guid: customer.guid || '',
  fullName: customer.full_name || '-',
  phoneNumber: customer.phone_number || '-',
  email: customer.email || '-',
  status: customer.status || 'Tidak diketahui',
  profilePicture: customer.profile_picture || '',
  customerType: customer.customer_type_data?.name || '-',
  gender: customer.gender || '-',
  dateOfBirth: customer.date_of_birth || '-',
  registeredOutlet: customer.outlet_data?.name || '-',
  address: customer.main_address || '-',
  city: customer.city || customer.outlet_data?.city_name || '-',
  province: customer.province || customer.outlet_data?.region_name || '-',
})

export const lookupGymMember = async (phone: string, email: string): Promise<GymMember | null> => {
  const response = await getCustomers({
    filter: {
      set_outlet_guid: false,
      outlet_guid: [],
      set_customer_type_guid: false,
      customer_type_guid: [],
      set_full_name: false,
      full_name: '',
      set_phone_number: true,
      phone_number: phone,
      set_email: true,
      email,
      set_gender: false,
      gender: [],
      set_date_of_birth: false,
      start_date: '',
      end_date: '',
      set_status: false,
      status: [],
    },
    limit: 10,
    page: 1,
    order: 'created_at',
    sort: 'DESC',
  })

  if (response?.response?.code !== RESP.SUCCESS) {
    throw new Error('CUSTOMER_LOOKUP_FAILED')
  }

  const customers = response.response.data
  if (!Array.isArray(customers) || customers.length === 0) return null

  return toGymMember(customers[0])
}
